import { useLayoutEffect, useRef } from 'react';
import { useAuth, useClerk } from '@clerk/clerk-react';
import { CLERK_JWT_TEMPLATE_NAME } from 'utils/auth/clerkJwtTemplate';
import { registerClerkForHttp } from 'utils/auth/clerkAuthActions';
import { clearClerkTokenGetter, setClerkTokenGetter } from 'utils/auth/token';

export default function ClerkBootstrap() {
  const { isLoaded, getToken } = useAuth();
  const clerk = useClerk();
  const getTokenRef = useRef(getToken);
  getTokenRef.current = getToken;

  //* useLayoutEffect + ref: register before child useEffects (SignalR / onboarding fetch).
  useLayoutEffect(() => {
    if (!isLoaded) return;

    registerClerkForHttp(clerk);

    //* FIX (2026-07-19): options.skipCache מועבר ל-Clerk כדי לאפשר הנפקת טוקן טרי
    //* אחרי 401 (ראו utils/axios.ts — retry לפני redirect ל-sign-in).
    setClerkTokenGetter((options) =>
      getTokenRef.current({
        template: CLERK_JWT_TEMPLATE_NAME,
        skipCache: options?.skipCache,
      }),
    );

    return () => {
      registerClerkForHttp(null);
      clearClerkTokenGetter();
    };
  }, [isLoaded, clerk]);

  return null;
}
